import React from 'react';


const Header = () => (
<div class="ui three item menu">
    <a class="active item"><font color="blue">We are opened!</font></a>
   </div>
);
export default Header;